module.exports = "<button class=\"btn btn-default btn-lg\"\n        spinning-wheel [is-spinning-wheel-active]=\"isSpinnerActive\" [is-spinning-wheel-dark]=\"'true'\"\n        (click)=\"saveAsPdf()\">\n    <i class=\"fa fa-file-pdf-o\"></i>Save As PDF\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.html
// module id = ./web/modern/components/jobs/modals/save-contract-pdf/save-contract-pdf.html
// module chunks = 0